import styled from "styled-components";

/**
 * Shared styled components for confirmation pages.
 * These provide consistent styling for the content within StatusBackground.
 */

export const ContentWrapper = styled.div`
  width: 100%;
  max-width: 570px;
  height: auto;
  & > h3 {
    font-size: 22px;
    font-weight: 700;
    margin: 0px;
    padding-bottom: 5px;
    border-bottom: 1px solid var(--red);
    margin-bottom: 30px;
    color: var(--white);
  }
  & > div {
    & > h3 {
      font-size: 22px;
      font-weight: 700;
      margin: 0px;
      padding-bottom: 5px;
      border-bottom: 1px solid var(--red);
      margin-bottom: 30px;
      color: var(--white);
    }
    @media screen and (max-width: 991px) {
      & > div {
        padding: 10px;
      }
    }
  }
  @media screen and (max-width: 991px) {
    & > div {
      padding: 10px;
    }
  }
`;

export const OuterBox = styled.div`
  background: rgba(0, 0, 0, 0.5);
  padding: 30px;
  text-align: center;
  color: var(--white);
  @media screen and (max-width: 991px) {
    padding: 10px;
  }
`;

export const InnerBox = styled.div`
  padding: 20px;
  background: rgba(0, 0, 0, 0.7);
  & > img {
    width: 50px;
    height: 50px;
    object-fit: contain;
    margin: 10px auto;
  }
  & > h4:nth-child(2) {
    font-weight: normal;
    margin: 0 0 15px;
    padding-bottom: 15px;
    border-bottom: 1px solid var(--rewards_grid);
  }
`;
